import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
import { CanonicalLogType } from "./DebugTypes";
export class Debug {
    static getDebugContext() {
        var _a;
        return (_a = this.debugContextStack.at(-1)) !== null && _a !== void 0 ? _a : { gameIndex: -1 };
    }
    ;
    static pushDebugContext(context) {
        this.debugContextStack.push(context);
    }
    static popDebugContext(context) {
        this.debugContextStack = this.debugContextStack.filter((item) => item !== context);
    }
    static log(text) {
        if (this.isServer) {
            return;
        }
        this.logInternal(text, this.getDebugContext());
    }
    static logInternal(text, context) {
        console.log(`$${context.gameIndex}: ${text}`);
    }
    // public static canonicalLog(game: GameLike, text: string): void {
    //     if (global.globalThis.Debug.isServer) {
    //         return;
    //     }
    //     if (this.canonicalLogType === CanonicalLogType.GameIndex && game.gameIndex === this.canonicalGameIndex) {
    //         console.log(text);
    //         return;
    //     }
    //     if (this.canonicalLogType === CanonicalLogType.SecretWordGiver) {
    //         if (!(game instanceof Contact3D)) {
    //             console.error('Canonical log type SecretWordGiver can only be used with the Contact3D game type!');
    //         }
    //         if ((game as Contact3D).gameState.data.secretWordGiverId === game.playerId) {
    //             console.log(text);
    //             return;
    //         }
    //     }
    // }
    static serverLog(text, record) {
        this.serverLogInternal(text, record, false);
    }
    static serverLogTrace(text, record) {
        this.serverLogInternal(text, record, true);
    }
    static serverLogInternal(text, record, logTrace) {
        if (!this.isServer) {
            return;
        }
        const err = {
            name: 'Trace',
        };
        // eslint-disable-next-line no-restricted-syntax
        Error.captureStackTrace(err, this.serverLogInternal);
        process.stdout.write(JSON.stringify(Object.assign({ msg: text, stack: logTrace ? err.stack : undefined }, (typeof (record) === 'string' ? { record } : record))) + '\n');
    }
    static setCanonicalLogType(input) {
        if (input.logType === CanonicalLogType.SecretWordGiver) {
            this.canonicalLogType = input.logType;
        }
        else {
            this.canonicalGameIndex = input.gameIndex;
            this.canonicalLogType = input.logType;
        }
    }
}
Debug.isServer = false;
Debug.canonicalLogType = CanonicalLogType.GameIndex;
Debug.canonicalGameIndex = 0;
Debug.debugContextStack = [];
const DebugReactContext = createContext(null);
export const DebugContextProvider = ({ value, children }) => {
    return _jsx(DebugReactContext.Provider, { value: value, children: children });
};
export const useDebug = () => {
    const debugContext = useContext(DebugReactContext);
    return {
        log: (text) => Debug.logInternal(text, debugContext),
    };
};
//# sourceMappingURL=Debug.js.map